import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PageWrapper, Loader, Alert, Pagination } from '../../components';
import Actions, { thunks } from '../../redux/modules/payments';

class Payments extends React.Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(thunks.getPayments());
    }
    
    viewPayment = payment => {
        console.log("PAYMENT:::::", payment)
    }

    onPageChanged = page => {
        const { updateProperty, dispatch } = this.props;
        updateProperty('page', page);
        dispatch(thunks.getPayments());
    }

    render() {
        const { 
            list,
            loading,
            error,
            updateProperty,
            page,
            nextPage
        } = this.props;
        return (
            <PageWrapper title="Payments List">
                <Loader show={loading}/>
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Payments"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th/>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                    {
                                                        list.length ? (
                                                            list.map(payment => (
                                                                <tr key={payment.id}>
                                                                    <td>{payment.id}</td>
                                                                    <td>{payment.name}</td>
                                                                    <td>{payment.email}</td>
                                                                    <td>{payment.phone}</td>
                                                                    <td>
                                                                        <button title="View Payment" className="btn btn-xs btn-info" onClick={() => this.viewPayment(payment)}>
                                                                            <i className="fa fa-eye"/>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No Records Found</td>
                                                            </tr>
                                                        )
                                                    }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        page={page}
                                        nextPage={nextPage}
                                        onPageChanged={this.onPageChanged}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    payments: {
        loading,
        error,
        list,
        page,
        nextPage,
    },
}) => ({
    loading,
    error,
    list,
    page,
    nextPage,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Payments)